export const FETCH_MENU_ITEMS = 'FETCH_MENU_ITEMS';
export const FETCH_MENU_ITEMS_SUCCESS = 'FETCH_MENU_ITEMS_SUCCESS';
export const FETCH_MENU_ITEMS_FAILURE = 'FETCH_MENU_ITEMS_FAILURE';
export const CHANGE_ACTIVE_MENU = 'CHANGE_ACTIVE_MENU';

export const defaultMenuState = {
  loading: false,
  error: null,
  menuItems: null,
  activeMenus: []
};

export const menuReducer = (state, action) => {
  switch (action.type) {
    case FETCH_MENU_ITEMS:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_MENU_ITEMS_SUCCESS: {
      return {
        ...state,
        loading: false,
        menuItems: action.menuItems
      };
    }

    case FETCH_MENU_ITEMS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error || true
      };
    }

    case CHANGE_ACTIVE_MENU: {
      const { iteration, activeIndex } = action;

      if (iteration === -1) {
        return {
          ...state,
          activeMenus: []
        };
      }

      let deepCopiedActiveMenus = [...state.activeMenus];
      deepCopiedActiveMenus[iteration] = activeIndex;

      if (activeIndex === -1) {
        deepCopiedActiveMenus = deepCopiedActiveMenus.slice(0, iteration);
      }

      if (deepCopiedActiveMenus.length > iteration) {
        deepCopiedActiveMenus = deepCopiedActiveMenus.slice(0, iteration + 1);
      }

      return {
        ...state,
        activeMenus: deepCopiedActiveMenus
      };
    }

    default:
      return state;
  }
};
